
import Vue from 'vue'
import { FTFactoryTicket } from '@/models/FTFactoryTicket';
import { EventsService } from '@/services/EventsService';
import FtProcess from './CFtProcess.vue'
import { mapState, mapGetters } from 'vuex';

export default Vue.extend({
  components: {
    FtProcess
  },
  props: {
    input: { type: Object, default: () => {} },
    data: { type: Object, default: () => {} },
    getVariable: { type: Function, default: () => () => {} },
    callFunction: { type: Function, default: () => () => {} },
    onChange: { type: Function, default: () => {} },
    parent: { type: Object, default: () => {} },
    errorResponse: { type: Object, default: () => {}}
  },
  data(): {
    valid: boolean,
    factoryTicket: FTFactoryTicket,
    rules: Array<any>
  } {
    return {
      valid: false,
      factoryTicket: new FTFactoryTicket(
        this.getVariable(this.input.config.orderDetailsVariable),
        this.getVariable(this.input.config.formVariable)
      ),
      rules: [ (value: any) => !!value || 'Required' ]
    }
  },
  computed: {
    ...mapState({
      goods: (state: any) => state.goods.items
    }),
    ...mapGetters(['getErrorFor'])
  },
  async mounted() {
    this.$watch(
      () => this.valid && this.factoryTicket.processIndex > 0, 
      (isFactoryTicketValid) => {
        this.$store.commit('setFormValidStatus', { isFactoryTicketValid });
      },
      {
        immediate: true
      }
    );
    this.$watch(
      () => this.getVariable(this.input.config.orderDetailsVariable),
      (order) => this.factoryTicket.order = order
    );
    EventsService.createEvent('isFactoryTicketValidValidation', this.validateForm, this);
  },
  methods: {
    validateForm: function() {
      // @ts-ignore
      this.$refs.form.validate();
      const isFactoryTicketValid = this.valid && this.factoryTicket.processes.length;
      this.$store.commit('setFormValidStatus', { isFactoryTicketValid });
    },
    getProcessError(processIndex: string): any {
      // @ts-ignore
      return this.getErrorFor(`unavailableGoods.${processIndex}`) || {};
    }
  }
})
